import { t } from "@lingui/macro";
import { ReactNode } from "react";

import TelegramIcon from "img/ic_telegram.svg?react";
import XIcon from "img/ic_x.svg?react";

type Link = {
  label: ReactNode;
  link: string;
  external?: boolean;
  isAppLink?: boolean;
};

type SocialLink = {
  link: string;
  name: string;
  icon: React.ReactNode;
};

export const getFooterLinks = (): Link[] => [
  { label: t`Charts by TradingView`, link: "https://www.tradingview.com/", external: true },
];

export const SOCIAL_LINKS: SocialLink[] = [
  { link: "https://x.com/hfdxprotocol", name: "Twitter", icon: <XIcon className="size-16" /> },
  { link: "https://t.me/HFDXTrading", name: "Telegram", icon: <TelegramIcon className="size-16" /> },
];
